// import { fabric } from 'fabric';
// import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useCallback } from 'react';

import { useSelectedColor } from '@ee-api/colors-api/useSelectedColor';
import { useAppSelector } from '@redux/hooks';
import { selectFabricCanvas } from '@redux/slices/fabricSlice';

import { generateCanvasJpeg } from '../canvas/drawing-tool/utils/drawing-helper';
import { cloneCanvasAndRemoveSelections } from './useCanvasClone';

/**
 * Provides methods that clone  the canvas (removes selections as well) when triggered
 */
export const useLazyCanvasClone = (): {
    /**Generates a PNG image of the canvas
     * @returns the url of the generated PNG or null if clone is not ready
     */
    generatePng: () => Promise<string>;
} => {
    const canvas = useAppSelector(selectFabricCanvas);
    const { selectedValue: selectedColor } = useSelectedColor();

    const generatePng = useCallback(async (): Promise<string> => {
        const canvasClone = await cloneCanvasAndRemoveSelections(canvas, selectedColor?.overlayColor);
        return generateCanvasJpeg(canvasClone, true);
    }, [canvas, selectedColor?.overlayColor]);

    return { generatePng };
};
